import {
  Bot20Regular,
  Person20Regular,
  Send16Regular,
} from "@fluentui/react-icons";
import { CurrentQuestionShelf } from "apps/diagnostics/externalDiagnostics/CurrentQuestionShelf/currentQuestionShelf";
import { Header } from "apps/diagnostics/externalDiagnostics/Header/header";
import { InterviewSidebar } from "apps/diagnostics/externalDiagnostics/InterviewSidebar/InterviewSidebar";
import { VOICE_OPTIONS } from "apps/diagnostics/common/constants";
import { useStyles } from "./brandingPreview.styles";
import { IBrandingPreviewProps } from "./brandingPreview.types";

const PREVIEW_LANGUAGE = VOICE_OPTIONS.find(
  (option) => option.key === "en-US",
)!;

const PLACEHOLDER_DIAGNOSTIC_NAME = "Lorem ipsum dolor sit";

const PLACEHOLDER_OBJECTIVES = [
  {
    name: "Consectetur adipiscing",
    text: "Consectetur adipiscing",
    questionNumber: 1,
    order: 1,
    user: {} as any,
  },
  {
    name: "Sed do eiusmod",
    text: "Sed do eiusmod",
    questionNumber: 2,
    order: 2,
    user: {} as any,
  },
  {
    name: "Ut labore dolore",
    text: "Ut labore dolore",
    questionNumber: 3,
    order: 3,
    user: {} as any,
  },
];

export const BrandingPreview = ({
  headerColor,
  headerLogoUrl,
  accentPalette,
}: IBrandingPreviewProps): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.outer}>
      <div className={styles.inner}>
        <div className={styles.headerArea}>
          <Header headerColor={headerColor} headerLogoUrl={headerLogoUrl} />
        </div>
        <div className={styles.body}>
          <div className={styles.sidebarWrapper}>
            <InterviewSidebar
              diagnosticName={PLACEHOLDER_DIAGNOSTIC_NAME}
              objectives={PLACEHOLDER_OBJECTIVES}
              currentObjectiveOrder={1}
              accentPalette={accentPalette}
            />
          </div>
          <div className={styles.content}>
            <div className={styles.messagesArea}>
              <div className={styles.aiBubbleRow}>
                <div className={styles.aiAvatar}>
                  <Bot20Regular />
                </div>
                <div className={styles.aiBubble}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit?
                </div>
              </div>
              <div className={styles.userBubbleRow}>
                <div className={styles.userBubble}>
                  Sed ut perspiciatis unde omnis iste natus.
                </div>
                <div className={styles.userAvatar}>
                  <Person20Regular />
                </div>
              </div>
            </div>
            <CurrentQuestionShelf
              question="Ut enim ad minim veniam, quis nostrud exercitation ullamco?"
              objectiveName="Sed do eiusmod"
              accentPalette={accentPalette}
              language={PREVIEW_LANGUAGE}
            />
            <div className={styles.inputContainer}>
              <div className={styles.inputCard}>
                <div className={styles.previewTabBar}>
                  <div className={styles.previewTabGroup}>
                    <div
                      className={styles.previewTabActive}
                      style={{
                        border: `1px solid ${accentPalette.accentOnWhite}`,
                        color: accentPalette.accentOnWhite,
                      }}
                    >
                      Text
                    </div>
                    <div className={styles.previewTab}>Voice</div>
                  </div>
                </div>
                <div className={styles.previewTextPanel}>
                  <div className={styles.previewTextPanelBody}>
                    <span className={styles.previewTextareaPlaceholder}>
                      Type your response here...
                    </span>
                    <div
                      className={styles.previewSendBtn}
                      style={{ backgroundColor: accentPalette.accentOnWhite }}
                    >
                      <Send16Regular
                        style={{ color: accentPalette.accentOnWhiteText }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
